import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { t } from "i18next";
import IconLocationOutline from "presentation/assets/iconLocationOutline";
import { emitOpenMapModal } from "presentation/components/commons/mapModalLocations/useMapModal";
import { isTestMarketCountry } from "utils/testMarket";
const CategoryShowMap = ({ filters, setFilters }) => {
    const normalizedCountry = (sessionStorage.getItem("country") || "").toString().trim().toUpperCase();
    const isTestMarket = isTestMarketCountry(normalizedCountry || "US");
    const handleClick = (event) => {
        event.preventDefault();
        if (filters.PickUpLocationCode && filters.ReturnLocationCode) {
            setFilters({
                ...filters,
                PickUpLocationCode: "",
                ReturnLocationCode: "",
            });
            return;
        }
        emitOpenMapModal({
            locationsCodes: [filters.PickUpLocationCode, filters.ReturnLocationCode],
        });
    };
    return (_jsx(_Fragment, { children: isTestMarket && _jsx("div", { className: `categories__item categories__item--map ${filters.PickUpLocationCode && filters.ReturnLocationCode && "categories__item--active"}`, "category-tittle": "openMap", onClick: handleClick, children: _jsxs("div", { className: "categories__item-inner", children: [_jsx("div", { className: "categories__image categories__image--map", children: _jsx(IconLocationOutline, {}) }), _jsxs("div", { className: "category-info", children: [_jsx("span", { className: "category-title", children: t('location-map-label') }), filters.PickUpLocationCode && filters.ReturnLocationCode && _jsx("span", { className: "category-price", children: t('2-offices-label') })] })] }) }) }));
};
export default CategoryShowMap;
